// NotFoundPage — 404 page.
import { Box, Typography, Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/** 404 — страница не найдена. */
export function NotFoundPage(): JSX.Element {
  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack spacing={2} alignItems="center" sx={{ textAlign: 'center', maxWidth: 480 }}>
        <Typography variant="h2" component="h1" sx={{ fontWeight: 600, color: 'text.secondary' }}>
          404
        </Typography>
        <Typography variant="h6">Страница не найдена</Typography>
        <Typography variant="body2" color="text.secondary">
          Запрашиваемая страница не существует или была удалена.
        </Typography>
        <Button component={RouterLink} to="/dashboard" variant="contained" sx={{ mt: 2 }}>
          На дашборд
        </Button>
      </Stack>
    </Box>
  );
}
